<template>
  <div>
    <div class="mb-16" id="air-temp-chart">
      <h3>Temperatura powietrza:</h3>
      <apexchart
        type="line"
        height="350"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
    <template v-if="sunHoursAvl">
      <div class="font-m mb-16 text-center">
        Godziny słoneczne w ciągu dnia:
      </div>
      <div class="mb-32 meteo-stats sunhours">
        <template v-for="({ month, sunhours }, idx) in climateData">
          <div class="meteo-stats__cell" :key="idx">
            <span class="d-block meteo-stats__month">{{ month }}</span>
            <span class="d-block meteo-stats__number">{{ sunhours }}</span>
          </div>
        </template>
      </div>
    </template>
    <div v-if="waterTemperaturesAvl" id="water-temp-chart">
      <h3>Temperatura wody:</h3>
      <apexchart
        type="area"
        height="350"
        :options="chartOptions2"
        :series="series2"
      ></apexchart>
    </div>
    <div
      v-if="relHumAvl || precipSumAvl"
      class="mb-16"
      id="precip-humidity-chart"
    >
      <h3>Opady i wilgotność powietrza:</h3>
      <apexchart
        :type="chartType"
        height="350"
        :options="chartOptions3"
        :series="series3"
      ></apexchart>
    </div>
    <template v-if="precipDaysAvl">
      <div class="font-m mb-16 text-center">
        Dni z opadami w ciągu miesiąca:
      </div>
      <div class="mb-32 meteo-stats precipitations">
        <template v-for="({ month, precipitationdays }, idx) in climateData">
          <div class="meteo-stats__cell" :key="idx">
            <span class="d-block meteo-stats__month">{{ month }}</span>
            <span class="d-block meteo-stats__number">{{
              precipitationdays
            }}</span>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "meteo-charts",
  props: {
    climateData: [Array, Object]
  },
  data: () => ({
    months: {},
    avgTemperatures: {},
    maxTemperatures: {},
    minTemperatures: {},
    precipitationSum: {},
    relHumidity: {},
    waterTemperatures: {},
    series: [],
    series2: [],
    series3: [],
    chartOptions: {},
    chartOptions2: {},
    chartOptions3: {},
    chartType: "line",
    waterTemperaturesAvl: true,
    sunHoursAvl: true,
    precipDaysAvl: true,
    precipSumAvl: true,
    relHumAvl: true
  }),
  methods: {
    getClimateData() {
      let months = [];
      let minTemp = [];
      let maxTemp = [];
      let avgTemp = [];
      let waterTemp = [];
      let precipSum = [];
      let relHum = [];

      for (let i = 0; i < this.climateData.length; i++) {
        if (this.climateData[i].sunhours == undefined) {
          this.sunHoursAvl = false;
        }
      }

      for (let i = 0; i < this.climateData.length; i++) {
        if (this.climateData[i].precipitationdays == undefined) {
          this.precipDaysAvl = false;
        }
      }

      for (let i = 0; i < this.climateData.length; i++) {
        months.push(this.climateData[i].month);
      }
      this.months = months;

      for (let i = 0; i < this.climateData.length; i++) {
        minTemp.push(this.climateData[i].minimumtemperature);
      }
      this.minTemperatures = minTemp;

      for (let i = 0; i < this.climateData.length; i++) {
        maxTemp.push(this.climateData[i].maximumtemperature);
      }
      this.maxTemperatures = maxTemp;

      for (let i = 0; i < this.climateData.length; i++) {
        avgTemp.push(this.climateData[i].averagetemperature);
      }
      this.avgTemperatures = avgTemp;

      for (let i = 0; i < this.climateData.length; i++) {
        if (this.climateData[i].watertemperature == undefined) {
          this.waterTemperaturesAvl = false;
        } else {
          this.waterTemperaturesAvl = true;
          waterTemp.push(this.climateData[i].watertemperature);
        }
      }
      this.waterTemperatures = waterTemp;

      for (let i = 0; i < this.climateData.length; i++) {
        if (this.climateData[i].precipitation == undefined) {
          this.precipSumAvl = false;
        } else {
          precipSum.push(this.climateData[i].precipitation);
          this.precipSumAvl = true;
        }
      }
      this.precipitationSum = precipSum;

      for (let i = 0; i < this.climateData.length; i++) {
        if (this.climateData[i].relativehumidity == undefined) {
          this.relHumAvl = false;
        } else {
          relHum.push(this.climateData[i].relativehumidity);
          this.relHumAvl = true;
        }
      }
      this.relHumidity = relHum;
    },

    updateChart() {
      this.getClimateData();
      let months = this.months;
      let minTemp = this.minTemperatures;
      let maxTemp = this.maxTemperatures;
      let avgTemp = this.avgTemperatures;
      let waterTemp = this.waterTemperatures;
      let precipSum = this.precipitationSum;
      let relHum = this.relHumidity;

      this.series = [
        {
          name: "Temp. maksymalna °C",
          data: maxTemp
        },
        {
          name: "Temp. średnia °C",
          data: avgTemp
        },
        {
          name: "Temp. minimalna °C",
          data: minTemp
        }
      ];

      this.chartOptions = {
        chart: {
          fontFamily: "'Nunito Sans Regular', sans-serif",
          height: 350,
          redrawOnParentResize: true,
          type: "line",
          toolbar: {
            tools: {
              download: false,
              pan: false
            }
          }
        },
        colors: ["#fa4d16", "#ffbf00", "#0098f1"],
        legend: {
          markers: {
            radius: 2
          }
        },
        stroke: {
          curve: "smooth",
          width: 2
        },
        xaxis: {
          tooltip: {
            enabled: false
          },
          categories: months,
          type: "category"
        },
        tooltip: {
          x: {
            show: false
          }
        }
      };

      this.series2 = [
        {
          name: "Temperatura wody °C",
          data: waterTemp
        }
      ];

      this.chartOptions2 = {
        chart: {
          fontFamily: "'Nunito Sans Regular', sans-serif",
          height: 350,
          redrawOnParentResize: true,
          type: "area",
          toolbar: {
            tools: {
              download: false,
              pan: false
            }
          }
        },
        fill: {
          type: "gradient",
          colors: ["#40b5cb"],
          gradient: {
            inverseColors: true,
            shadeIntensity: 1,
            opacityFrom: 0.75,
            opacityTo: 0.65,
            stops: [0, 100]
          }
        },
        dataLabels: {
          enabled: false
        },
        colors: ["#40b5cb"],
        stroke: {
          colors: ["#40b5cb"],
          curve: "smooth",
          width: 2
        },
        xaxis: {
          tooltip: {
            enabled: false
          },
          categories: months,
          type: "category"
        },
        tooltip: {
          x: {
            show: false
          }
        }
      };

      let series3Data = [];
      let chartOptions3Data = [];
      const barColor = "#0098f1";
      const lineColor = "#966bc3";
      const yAxisText = undefined;

      let precipSumArr = {
        name: "Suma opadów deszczu mm",
        type: "column",
        data: precipSum
      };

      let relHumArr = {
        name: "Wilgotność względna %",
        type: "line",
        data: relHum
      };

      if (this.precipSumAvl && this.relHumAvl) {
        series3Data.push(precipSumArr, relHumArr);
        chartOptions3Data.push({
          colors: [barColor, lineColor],
          stroke: [0, 2],
          yaxis: [
            { title: { text: yAxisText } },
            { opposite: true, title: { text: yAxisText } }
          ]
        });
      } else if (this.precipSumAvl && !this.relHumAvl) {
        this.chartType = "bar";
        series3Data.push(precipSumArr);
        chartOptions3Data.push({
          colors: [barColor],
          stroke: null,
          yaxis: [{ title: { text: yAxisText } }]
        });
      } else if (!this.precipSumAvl && this.relHumAvl) {
        series3Data.push(relHumArr);
        chartOptions3Data.push({
          colors: [lineColor],
          stroke: [2],
          yaxis: [{ title: { text: yAxisText } }]
        });
      }

      this.series3 = series3Data;

      this.chartOptions3 = {
        chart: {
          fontFamily: "'Nunito Sans Regular', sans-serif",
          height: 350,
          redrawOnParentResize: true,
          type: this.chartType,
          toolbar: {
            tools: {
              download: false,
              pan: false
            }
          }
        },
        colors: chartOptions3Data[0].colors,
        legend: {
          markers: {
            radius: 2
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth",
          width: chartOptions3Data[0].stroke
        },
        xaxis: {
          tooltip: {
            enabled: false
          },
          categories: months,
          type: "category"
        },
        yaxis: chartOptions3Data[0].yaxis,
        tooltip: {
          x: {
            show: false
          }
        }
      };
    }
  },
  mounted() {
    this.updateChart();
  },
  watch: {
    climateData: function() {
      this.updateChart();
    }
  },
  components: {
    apexchart: VueApexCharts
  }
};
</script>

<style lang="scss" scoped>
.meteo-stats {
  $self: &;
  display: flex;
  flex-wrap: wrap;

  &__cell {
    border-radius: 3px;
    margin-bottom: 2px;
    overflow: hidden;
    text-align: center;
    width: 25%;

    @media (min-width: $screen-xs) {
      width: percentage(1/12);
    }
  }

  &__month {
    @include font-m();

    &:first-letter {
      text-transform: uppercase;
    }
  }

  &__month,
  &__number {
    margin: 0 1px;
    padding: 3px;
  }

  &.sunhours {
    #{ $self }__month {
      background-color: $yellow-default;
    }

    #{ $self }__number {
      background-color: lighten($yellow-default, 30%);
    }
  }

  &.precipitations {
    #{ $self }__month {
      background-color: lighten($blue-light, 10%);
    }

    #{ $self }__number {
      background-color: lighten($blue-light, 40%);
    }
  }
}
</style>
